import { Body, Button, Grid, Lockup, TextButton, theme, VerticalSpacer } from '@superhi/design'
import React from 'react'

import { Wrapper } from '../styles'

import { Buttons } from './styles'

type Version = '1' | '2'

const VERSION: Record<
  Version,
  {
    GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span']
    GRID_1_CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span']
  }
> = {
  '1': {
    GRID_1_CELL_SPAN_1: { small: 'full', medium: 7, large: 6, xlarge: 6 },
    GRID_1_CELL_SPAN_2: { small: 'full', medium: 8, large: 6, xlarge: [8, 12] },
  },
  '2': {
    GRID_1_CELL_SPAN_1: { small: 'full', medium: 7, large: 5, xlarge: 5 },
    GRID_1_CELL_SPAN_2: { small: 'full', medium: 8, large: 7, xlarge: 7 },
  },
}

type Props = Pick<
  React.ComponentProps<typeof Lockup>,
  | 'title'
  | 'titleMaxWidth'
  | 'subtitle'
  | 'subtitleMarkdown'
  | 'subtitleRichText'
  | 'subtitleMaxWidth'
> & {
  buttonText?: string
  buttonUrl?: string
  buttonIsExternal?: boolean
  buttonOnClick?: () => void
  secondaryButtonText?: string
  secondaryButtonOnClick?: () => void
  version?: Version
  backgroundColor?: keyof typeof theme.colors
}

const GRID_1_ROW_GAP = { small: 32, medium: 48 }
const GRID_1_CELL_2_ORDER = { small: -1, medium: -1 }

export const PageHeaderProduct: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  titleMaxWidth,
  subtitle,
  subtitleMarkdown,
  subtitleRichText,
  subtitleMaxWidth,
  buttonText,
  buttonUrl,
  buttonOnClick,
  buttonIsExternal,
  secondaryButtonText,
  secondaryButtonOnClick,
  children,
  version = '1',
  backgroundColor,
  ...commonProps
}) => (
  <Wrapper
    data-component-name="PageHeaderProduct"
    {...commonProps}
    $compact={false}
    $align="left"
    $backgroundColor={backgroundColor}
  >
    <Grid rowGap={GRID_1_ROW_GAP}>
      <Grid.Cell span={VERSION[version].GRID_1_CELL_SPAN_1}>
        <VerticalSpacer amount={{ small: 24, medium: 32, large: 40 }}>
          <Lockup
            title={title}
            titleMaxWidth={titleMaxWidth}
            subtitle={subtitle}
            subtitleMarkdown={subtitleMarkdown}
            subtitleRichText={subtitleRichText}
            subtitleMaxWidth={subtitleMaxWidth}
            align="left"
            level="1"
          />

          {(buttonText || secondaryButtonText) && (
            <div>
              <Buttons>
                {buttonText && (
                  <Button
                    href={buttonUrl}
                    isExternal={buttonIsExternal}
                    onClick={buttonOnClick}
                    level="1"
                  >
                    {buttonText}
                  </Button>
                )}
                {secondaryButtonText && (
                  <TextButton onClick={secondaryButtonOnClick} color="BLUE_50" hoverColor="BLUE_60">
                    <Body level="2">{secondaryButtonText}</Body>
                  </TextButton>
                )}
              </Buttons>
            </div>
          )}
        </VerticalSpacer>
      </Grid.Cell>

      {children && (
        <Grid.Cell order={GRID_1_CELL_2_ORDER} span={VERSION[version].GRID_1_CELL_SPAN_2}>
          {children}
        </Grid.Cell>
      )}
    </Grid>
  </Wrapper>
)

export default PageHeaderProduct
